export default "__VITE_ASSET__feba3e81__"